import { InvitationStatus } from "src/features/broadcast/enums/invites";

export const isSentInvitation = (status: InvitationStatus): boolean =>
  status === InvitationStatus.SENT;
